import React, { FC } from 'react'

const SlashCircleIcon: FC = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z"
        fill="#BA1A1A" />
      <path d="M4.89984 19.75C4.70984 19.75 4.51984 19.68 4.36984 19.53C4.07984 19.24 4.07984 18.76 4.36984 18.47L18.3698 4.47C18.6598 4.18 19.1398 4.18 19.4298 4.47C19.7198 4.76 19.7198 5.24 19.4298 5.53L5.42984 19.53C5.27984 19.68 5.08984 19.75 4.89984 19.75Z"
        fill="#BA1A1A" />
    </svg>

  )
}

export default SlashCircleIcon